module.exports = __webpack_public_path__ + "static/img/gaozhongdili8.45327ebf.jpg";